import {Component} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, ValidatorFn} from '@angular/forms';
import {FunctionGeneralSettingsComponent} from './function-general-settings.component';

@Component({
  selector: 'app-function-general-settings-visual-fixture',
  imports: [ReactiveFormsModule, FunctionGeneralSettingsComponent],
  template: `
    <main class="function-general-settings-visual-fixture">
      <app-function-general-settings [settingsForm]="settingsForm"></app-function-general-settings>
    </main>
  `,
  styles: [`
    .function-general-settings-visual-fixture {
      display: block;
      margin: 0 auto;
      max-width: 720px;
      padding: 24px;
    }
  `]
})
export class FunctionGeneralSettingsVisualFixtureComponent {
  private readonly fixtureState = typeof window === 'undefined'
    ? 'connect-enabled'
    : new URL(window.location.href).searchParams.get('functionGeneralSettingsVisualFixture') || 'connect-enabled';
  private readonly invalidRequiredPropertyValidator: ValidatorFn = () =>
    this.fixtureState === 'invalid-required-property' ? {requiredPropertyMissing: true} : null;

  readonly settingsForm = new FormGroup({
    type: new FormControl(this.fixtureState === 'invalid-required-property' ? 'Logic App' : 'Workflow'),
    endpoint: new FormControl(''),
    bearerKey: new FormControl(''),
    contractVersion: new FormControl('configured-function.v1'),
    outputSchema: new FormControl('{\n  "type": "object",\n  "properties": {},\n  "additionalProperties": false\n}'),
    authority: new FormControl('configured_provider'),
    timeoutMs: new FormControl(15000),
    maximumAttempts: new FormControl(1),
    initialBackoffMs: new FormControl(250),
    maximumConcurrency: new FormControl(1),
    requestMethod: new FormControl('POST'),
    requestArgumentPlacement: new FormControl('json_body'),
    idempotencyMode: new FormControl('provider_call_id'),
    idempotencyHeaderName: new FormControl('Idempotency-Key'),
    argumentLookupsJson: new FormControl('[]'),
    assistantMediaHosts: new FormControl(''),
    waitMessage: new FormControl('Preparing your workflow...'),
    parameters: new FormControl(
      this.fixtureState === 'invalid-required-property'
        ? '{\n  "type": "object",\n  "properties": {\n    "tollef_antall_fellesdrer": { "type": "string" }\n  },\n  "required": ["tollef_antall_fellesdorer"],\n  "additionalProperties": false\n}'
        : '{\n  "workflowId": "lead-enrichment",\n  "step": "entry"\n}',
      this.invalidRequiredPropertyValidator)
  });

  constructor() {
    if (this.fixtureState === 'invalid-required-property') {
      this.settingsForm.controls.parameters.markAsTouched();
    }
  }
}
